import { createSlice } from '@reduxjs/toolkit';

const memberSlice = createSlice({
  name: 'member',
  initialState: {
    rows: [],
    reportingRows: [],
  },
  reducers: {
    replaceData(state, action) {
      state.rows = action.payload;
    },
    replaceReportingData(state, action) {
      state.reportingRows = action.payload;
    },
  },
});

export const memberActions = memberSlice.actions;

export default memberSlice;